import { Typography } from "@mui/material";
import { ServiceModalOption } from "../ServiceModal.types";
import { ServiceModalOptionsList } from "../ServiceModalOptions.component";
import { CommentPlusIcon } from "@icons/CommentPlusIcon";
import { EditIcon } from "@icons/EditIcon";
import { DeleteIcon } from "@icons/DeleteIcon";
import { ShareIcon } from "@icons/ShareIcon";
import { ReportIcon } from "@icons/ReportIcon";
import { SERVICE_MODALS_OPTIONS_STATES } from "../../ServiceFunctionsModal.types";
import { shortAndShareEntityOnMobile } from "@infrastructure/Helpers/SharingEntity";
import React from "react";
import { ModalPostReactionsListTooltip } from "@shared/Components/Tippspiel/Reactions/ModalReactionsLists/ModalPostReactionsListTooltip";
import { PostDetailsPageActions } from "../../PostDetailsModal/PostDetailsModal";
import { isSharingNativelySupported } from "../../../../Pages/TruckTourFeedPage/Helpers/ShareSupported";

export default function StartingOptions({
    selectedPost,
    setOpen,
    onEditOptionClickHandler,
    setModalCurrentAction,
    showDesktopSharingOptions,
    handleCommentInputFocus,
    isEditAvailable,
    navigateToPostWithAction,
    isOwnPost,
    groupId,
}: any) {
    const selectedPostData = selectedPost.data;
    function onCommentOptionClickHandler(e) {
        if (handleCommentInputFocus) {
            setOpen(false);
            handleCommentInputFocus(e, selectedPostData.id);
        } else {
            navigateToPostWithAction(
                selectedPostData?.id,
                PostDetailsPageActions.WRITE_COMMENT,
            );
            setOpen(false);
        }
    }

    const isSharingAvailableInApp = isSharingNativelySupported();
    const postOptions: ServiceModalOption[] = [];

    if (isOwnPost) {
        if (isEditAvailable && onEditOptionClickHandler) {
            postOptions.push({
                headline: "Beitrag ändern",
                icon: <EditIcon />,
                onOptionClickHandler: () => {
                    if (onEditOptionClickHandler) {
                        setOpen(false);
                        onEditOptionClickHandler(selectedPostData);
                    }
                },
            });
        }
        postOptions.push({
            headline: "Beitrag löschen",
            icon: <DeleteIcon />,
            onOptionClickHandler: () => {
                setModalCurrentAction(
                    SERVICE_MODALS_OPTIONS_STATES.DELETING_POST,
                );
            },
        });
        if (isSharingAvailableInApp) {
            postOptions.push({
                headline: "Teilen",
                icon: <ShareIcon />,
                onOptionClickHandler: () => {
                    if (showDesktopSharingOptions) {
                        setModalCurrentAction(
                            SERVICE_MODALS_OPTIONS_STATES.SHARING_POST,
                        );
                        return;
                    }
                    shortAndShareEntityOnMobile(
                        groupId,
                        selectedPostData.id,
                        selectedPostData.group.name,
                        () =>
                            setModalCurrentAction(
                                SERVICE_MODALS_OPTIONS_STATES.UNSUCCESSFUL_SHORTENING_SHARING_LINK,
                            ),
                        () => setOpen(false),
                    );
                },
            });
        }
        postOptions.push({
            headline: "Kommentieren",
            icon: <CommentPlusIcon />,
            onOptionClickHandler: onCommentOptionClickHandler,
        });
    } else {
        postOptions.push({
            headline: "Kommentieren",
            icon: <CommentPlusIcon />,
            onOptionClickHandler: onCommentOptionClickHandler,
        });
        if (isSharingAvailableInApp) {
            postOptions.push({
                headline: "Teilen",
                icon: <ShareIcon />,
                onOptionClickHandler: () => {
                    if (showDesktopSharingOptions) {
                        setModalCurrentAction(
                            SERVICE_MODALS_OPTIONS_STATES.SHARING_POST,
                        );
                        return;
                    }
                    shortAndShareEntityOnMobile(
                        groupId,
                        selectedPostData.id,
                        selectedPostData.group.name,
                        () =>
                            setModalCurrentAction(
                                SERVICE_MODALS_OPTIONS_STATES.UNSUCCESSFUL_SHORTENING_SHARING_LINK,
                            ),
                        () => setOpen(false),
                    );
                },
            });
        }
        if (!selectedPostData.status.isEditorial) {
            postOptions.push({
                headline: "Missbrauch melden",
                icon: <ReportIcon />,
                onOptionClickHandler: () => {
                    setModalCurrentAction(
                        SERVICE_MODALS_OPTIONS_STATES.REPORTING_CONTENT,
                    );
                },
            });
        }
    }

    const reactOnPost = selectedPost.postActions.createReactOnPost?.(
        selectedPostData.id.toString(),
    );
    const modalContent = (
        <>
            <ModalPostReactionsListTooltip
                reactOnEntity={reactOnPost}
                postId={selectedPostData.id.toString()}
                successCallback={() => setOpen(false)}
            />
            <ServiceModalOptionsList options={postOptions} />
        </>
    );

    const modalTitle = <Typography>Was möchtest Du tun?</Typography>;

    return { modalTitle, modalContent };
}
